import ReactInputMask from "react-input-mask";

import styled, { css } from "styled-components";

const backgroundColor = ({ theme }) => {
  return theme.colors.neutral.cinza900;
};

const disabledBackgroundColor = ({ theme }) => {
  return theme.colors.neutral.cinza900;
};

const placeHolderColor = ({ theme }) => {
  return theme.colors.neutral.cinza300;
};

const padding = ({ size }) => {
  switch (size) {
    case "xs":
      return "8px";
    case "lg":
      return "16px";

    case "sm":
    case "md":
    default:
      return "12px";
  }
};

const fontSize = ({ size }) => {
  switch (size) {
    case "xs":
      return "12px";
    case "sm":
      return "14px";
    case "lg":
      return "20px";

    case "md":
    default:
      return "16px";
  }
};

const color = ({ disabled, theme }) => {
  // Área comum (fundo escuro): texto claro (cinza100) quando desabilitado
  // (somente leitura), para facilitar a leitura.
  if (disabled) return theme.colors.neutral.cinza100;

  return theme.colors.neutral.white;
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: none;
  color: ${color};

  grid-area: ${({ gridArea }) => gridArea};
  margin: ${({ margin }) => margin};
`;

export const Label = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  line-height: 20px;
  letter-spacing: 0.02em;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      background-color: ${disabledBackgroundColor};
    `}
`;

export const RequiredDot = styled.div`
  margin: 2px 0;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
`;

export const MaskedInputStyleStructure = styled(ReactInputMask)`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  border-radius: 4px;
  width: 100%;
  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;

export const InputStylesStructure = styled.textarea`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  color: ${color};
  /* border-radius: 4px; */
  width: 100%;
  height: ${({ height }) => height || "100%"};
  resize: none;
  overflow: auto;
  outline: none;

  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;
